import api from '@/api'

export const categoryActions = {
	async list({ state, commit }, params = {}) {
    console.log("TCL:  ~ file: actions.js ~ line 5 ~ list ~ state", state)
		let response

		let { url } = state

		if (params && params.flat) {
			url = `${url}/flat`
		}

		const size = params && params.size ? params.size : state.query.size
		const from = params && params.from ? params.from : state.query.from

		const filter = {
			size,
			from,
			sort: [
				{
					[state.sortBy.field]: {
						order: state.sortBy.direction,
					},
				},
			],
			query: {
				bool: {
					must: [
						{
							bool: {
								should: [
									{
										bool: {
											should: [
												{
													match: {
														name: {
															query: state.filters.searchQuery,
															operator: 'and',
															zero_terms_query: 'all',
															fuzziness: 'AUTO',
														},
													},
												},
												{
													match_phrase_prefix: {
														name: {
															query: state.filters.searchQuery,
															slop: 50,
														},
													},
												},
											],
										},
									},
								],
							},
						},
					],
				},
			},
		}

		try {
			response = await api().put(url, { filter })
			const { category } = response.data.data
			commit('SET_CATEGORIES', category)
			return Promise.resolve(category)
		} catch (err) {
			commit('SET_CATEGORIES', [])
			return Promise.resolve([])
		}
	},

	async quickList({ state }, filterTerm) {
		let resp

		const query = {
			query: {
				bool: {
					must: [],
				},
			},
		}

		if (filterTerm) {
			query.query.bool.must.push({
				match_phrase_prefix: {
					name: {
						query: filterTerm,
						slop: 10,
					},
				},
			})
		}

		query.size = state.query.size
		query.from = 0

		try {
			resp = await api().put(`${state.url}/flat`, {
				filter: query,
			})
			// once we have data, format it into an id/label object
			const toReturn = resp.data.data.category.map((item) => ({
				id: item.id,
				name: item.name,
			}))
			return Promise.resolve(toReturn)
		} catch (error) {
			if (
				error.response.status === 404 &&
				error.response.data.data.length === 0
			) {
				return Promise.resolve([])
			}
			return Promise.reject(error.response.data)
		}
	},

	async read({ commit, state }, id) {
		let response

		try {
			response = await api().get(`${state.url}/${id}`)
			const { category } = response.data.data
			commit('SET_CURRENT_CATEGORY', category[0])
			return Promise.resolve(category[0])
		} catch (err) {
			return Promise.reject(new Error(err))
		}
	},

	async edit({ state, commit, dispatch }) {
		let response

		const payload = state.currentCategory

		payload.description = payload.description ? payload.description : ''

		try {
			response = await api().put(`${state.urlSingular}/${payload.id}`, {
				category: payload,
			})
			dispatch('list')
			dispatch(
				'notifications/create',
				{
					body: 'The category was updated',
					type: 'success',
				},
				{ root: true }
			)
			commit('RESET_CURRENT_CATEGORY')
			return Promise.resolve(response.data.data.category)
		} catch (err) {
			return Promise.reject(new Error(err))
		}
	},

	async add({ state, commit, dispatch }) {
		let response

		const payload = state.currentCategory
    console.log("TCL:  ~ file: actions.js ~ line 166 ~ add ~ payload", payload)

		payload.description = payload.description ? payload.description : ''

		try {
			response = await api().post(state.urlSingular, {
				category: payload,
			})
			dispatch('list')
			dispatch(
				'notifications/create',
				{
					body: 'The category was created',
					type: 'success',
				},
				{ root: true }
			)
			commit('RESET_CURRENT_CATEGORY')
			return Promise.resolve(response.data.data.category)
		} catch (err) {
			return Promise.reject(new Error(err))
		}
	},

	async delete({ commit, dispatch, state }, id) {
		api()
			.delete(`${state.urlSingular}/${id}`)
			.then(() => {
				dispatch('list')
				dispatch(
					'notifications/create',
					{
						body: 'The category was deleted',
						type: 'success',
					},
					{ root: true }
				)
			})
			.catch((err) => {
				/**
				 * In the case we have deleted the last item in the list
				 */
				dispatch('list')
				commit('SET_ERROR', err)
			})
	},
}
